/**
 * ACCOUNT-COLORS.WIDGET
 * Customize account colors as superadmin
 */

import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"
import Space from "@/components/space"
import HomeTemplatesWidget from "@/widgets/home-templates.widget"
import HomeResourcesWidget from "@/widgets/home-resources.widget"
import HomeAccountsWidget from "@/widgets/home-accounts.widget"
import HomeCalendarWidget from "@/widgets/home-calendar.widget"
import HomeSurveysWidget from "@/widgets/home-surveys.widget"

interface StateProps {
  _session: Session
}

function SurveyHomeWidget(props: StateProps) {
  return (
    <div className="flex">
      <Space />
      {props._session.interfaceType === "ADMIN_PARENT" ? (
        <div style={{ marginTop: "14px" }} className="flex flex1">
          <div>
            <HomeTemplatesWidget />
            <HomeResourcesWidget />
          </div>

          <div className="width-20" />

          <div className="flex1 flex" style={{ width: 460 }}>
            <HomeAccountsWidget />
          </div>
        </div>
      ) : (
        <div className="flex" style={{ marginTop: 40 }}>
          <div style={{ width: 400 }} className="flex">
            <HomeCalendarWidget />
          </div>

          <div className="width-20" />

          <div className="flex1">
            <HomeSurveysWidget />
            <div className="flex">
              <HomeTemplatesWidget />
              <div className="width-20" />
              <HomeResourcesWidget />
            </div>
          </div>
        </div>
      )}

      <Space />
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(SurveyHomeWidget)
